export var WIDTH_TO_HEIGHT_RATIO_THRESHOLD_TO_CROP_SUPER_WIDE = 2;
export var WIDTH_TO_HEIGHT_RATIO_THRESHOLD_TO_CROP_SUPER_TALL = 0.57;
export var WIDTH_TO_HEIGHT_RATIO_TO_SET_FOR_OVERSIZED = 1.78; // 16 (width) / 9 (height)
export var WIDTH_TO_HEIGHT_RATIO_TO_SET_FOR_TINY = 0.57; // 9 (width) / 16 (height)
export var TINY_IMAGE_WIDTH_THRESHOLD = 50;
export var TINY_IMAGE_HEIGHT_THRESHOLD = 50;
export var TINY_IMAGE_SIZE_MULTIPLIER = 2;
//# sourceMappingURL=constants.js.map